import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ImageMapBanner from 'yoda-core-components/lib/components/ImagemapBannerResponsive/ImagemapBannerResponsive';
import { replaceSubdomain } from 'yoda-core-components/lib/helpers/Utils/Utils';

class ShoppableImages extends PureComponent {
    static propTypes = {
        channels: PropTypes.oneOfType([PropTypes.array]),
        automationId: PropTypes.string,
        preferences: PropTypes.object,
    };

    static defaultProps = {
        channels: [],
        automationId: 'image-map-Banner',
        preferences: {},
    };

    constructLeaf = (mapArea) => {
        return mapArea.map((data = {}) => {
            const bannerData = {};
            bannerData.ppid = data.ppid;

            return { ...data, ...bannerData };
        });
    };

    openMiniPdpEvent = (ppid) => {
        const customEvent = document.createEvent('CustomEvent');
        customEvent.initCustomEvent('miniPDP.open', true, true, { ppId: ppid });
        document.dispatchEvent(customEvent);
    };

    render() {
        const { channels, automationId, preferences } = this.props;
        const bannerData = channels[0];
        let imageurl = get(bannerData, 'image.url', '');
        imageurl = replaceSubdomain(imageurl, preferences);
        const imageDimensions = get(bannerData, 'image.dimensions', '');

        return (
            <ImageMapBanner
                imageUrl={imageurl}
                imagemapArea={this.constructLeaf(get(bannerData, 'hotspots', []))}
                imageAltText={get(bannerData, 'image.altText', '')}
                imageWidth={imageDimensions ? imageDimensions.width : ''}
                imageHeight={imageDimensions ? imageDimensions.height : ''}
                analyticsTag={get(bannerData, 'analyticsTag', '')}
                automationId={automationId}
                location="hp-shoppable-image"
                hasPin
                onClick={this.openMiniPdpEvent}
            />
        );
    }
}

export default ShoppableImages;
